import { ReactNode } from "react";

import {
  ReferalAuthor,
  ReferalCompany,
  ReferalContainer,
  ReferalHeader,
  ReferalText,
} from "./Referals.styled";

interface ReferelBodyProps {
  title: string;
  author: string;
  company: string;
  children?: ReactNode;
}

export const ReferelBody = ({
  title,
  author,
  company,
  children,
}: ReferelBodyProps) => {
  return (
    <ReferalContainer>
      <ReferalHeader>{title}</ReferalHeader>
      <ReferalText>{children}</ReferalText>
      <ReferalAuthor>{author}</ReferalAuthor>
      <ReferalCompany>{company}</ReferalCompany>
    </ReferalContainer>
  );
};
